<!-- Sales Trend: multi-series D3 line chart with a brush range selector -->
<div class="emd-card mb-3">
  <emd-widget-header
    title="Sales Trend"
    selectionOrigin="details-trend"
    infoText="Monthly sales quantity per wholesaler. Click a line to stage that wholesaler as a selection; click a legend entry to hide its series; drag the strip below the chart to zoom the window."
  >
    <emd-pill-group
      emdHeaderCenter
      [options]="groupModes"
      [(value)]="groupBy"
      size="lg"
      ariaLabel="Group sales trend by"
    ></emd-pill-group>

    <emd-toggle [value]="unitsToggle" (valueChange)="onUnitsToggle($event)"></emd-toggle>
  </emd-widget-header>

  <!-- The chart draws its own interactive legend (click to toggle a series),
       so this card does not add a second one. -->
  <div class="emd-trend-host">
    <emd-multi-line-trend-chart
      [data]="trendData"
      [colors]="trendColors"
      [dateFormat]="bucket"
      [chartHeight]="468"
      [valueLabel]="trendValueLabel"
      [selectedSeries]="selectedWholesalers"
      (seriesClick)="onSeriesClick($event)"
    ></emd-multi-line-trend-chart>
  </div>
</div>

<!-- Sales Overview: expandable ag-grid (parent wholesaler -> child locations) -->
<div class="emd-card">
  <emd-widget-header
    title="Sales Overview"
    selectionOrigin="details-grid"
    [csv]="true"
    (csvExport)="overviewGrid.exportCsv('sales-overview')"
    infoText="Sales by wholesaler with per-location drill-down; the columns are the weeks of the selected window. Search filters both levels."
  >
    <emd-pill-group
      emdHeaderCenter
      [options]="overviewModes"
      [(value)]="overviewMode"
      size="lg"
      ariaLabel="Show sales or returns"
    ></emd-pill-group>

    <label class="emd-search">
      <mat-icon>search</mat-icon>
      <input
        type="text"
        placeholder="Search..."
        [ngModel]="searchText"
        (ngModelChange)="onSearch($event)"
      />
    </label>
  </emd-widget-header>

  <div class="emd-grid-host">
    <emd-hierarchical-grid
      #overviewGrid
      [rowData]="overviewRows"
      [columnDefs]="overviewColumnDefs"
      [childColumnDefs]="overviewChildColumnDefs"
      [grandTotal]="false"
      [height]="470"
      [selected]="selectedWholesalers"
      (rowSelect)="onRowSelect($event)"
    ></emd-hierarchical-grid>
  </div>
</div>
